'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyOrIndexToProperty = require('./keyOrIndexToProperty');

var _keyOrIndexToProperty2 = _interopRequireDefault(_keyOrIndexToProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    return function (parcelData) {
        var property = (0, _keyOrIndexToProperty2.default)(key)(parcelData);
        if (typeof property !== "number") {
            throw new Error('Cannot find index on non-indexed parcelData');
        }
        return property;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/keyOrIndexToIndex.js
// module id = 102
// module chunks = 35783957827783